import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import { Rating } from '@medprev-web-app/api-graphql-client';

import { EntityBar } from './entity-bar.component';

interface EntityBarContainerProps {
  rating: Rating;
}

function RatingCount({ count }: { count: number }) {
  if (!count) {
    return null;
  }

  const label = `${count} ${count === 1 ? 'avaliação' : 'avaliações'}`;

  return (
    <span
      id="rating-count-label"
      data-testid={DataTestIdEnum.ENTITY_COUNT_RATING}
      className="text-gray-600"
      aria-label={label}
    >
      {label}
    </span>
  );
}

export function EntityBarContainer({ rating }: EntityBarContainerProps) {
  const { count } = rating.fiveStars;

  return (
    <div
      className="w-full space-y-4"
      aria-labelledby="rating-count-label"
      data-testid={DataTestIdEnum.ENTITY_BAR_CONTAINER}
    >
      <RatingCount count={count || 0} />
      <EntityBar rating={rating} />
    </div>
  );
}
